import { render, staticRenderFns } from "./AlertCreateFacture.vue?vue&type=template&id=2d9f52f6&scoped=true"
import script from "./AlertCreateFacture.vue?vue&type=script&lang=js"
export * from "./AlertCreateFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f52f6",
  null
  
)

export default component.exports